'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapPropsAndThemeToStyle = exports.defaultStyle = undefined;

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaultStyle = exports.defaultStyle = {
  textAlign: 'center',
  minWidth: '100px',
  flex: '1 0 auto',
  cursor: 'pointer',
  '& .progressIndicator': {
    height: '.5em',
    marginTop: '.25em'
  },
  '&': {
    margin: '2px'
  }
};

var mapPropsAndThemeToStyle = exports.mapPropsAndThemeToStyle = function mapPropsAndThemeToStyle(_ref) {
  var active = _ref.active,
      completed = _ref.completed,
      disabled = _ref.disabled,
      onClick = _ref.onClick,
      linear = _ref.linear;
  var theme = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var baseStyles = function () {
    var rootStyles = {
      color: 'gray',
      fontWeight: 100,
      '& button': {
        color: theme.colors.primary
      },
      '& .progressIndicator': {
        backgroundColor: theme.colors.disabled
      }
    };

    if (disabled) {
      rootStyles = (0, _extends3.default)({}, rootStyles, {
        color: theme.colors.disabled,
        '&': {
          cursor: 'not-allowed',
          color: theme.colors.disabled
        },
        '& button': {
          cursor: 'not-allowed',
          color: 'lightgray'
        }
      });
    }
    return !disabled && onClick && !linear ? (0, _assign2.default)(rootStyles, {
      '&': { cursor: 'pointer' },
      '& button': { cursor: 'pointer' }
    }) : rootStyles;
  }();

  if (completed) {
    baseStyles.color = '#AFD1C3';
    baseStyles['&'] = {
      fontWeight: '100',
      color: '#AFD1C3'
    };
    baseStyles['& button'] = {
      fontWeight: '100',
      color: 'black'
    };
    baseStyles['& .progressIndicator'] = {
      backgroundColor: '#AFD1C3'
    };
  }

  if (active && !completed) {
    baseStyles.color = theme.colors.primary;
    baseStyles['& button'] = {
      color: theme.colors.primary
    };
    baseStyles.fontWeight = '900';
    baseStyles.margin = '15px';
    baseStyles['& .progressIndicator'] = {
      fontWeight: '800',
      backgroundColor: theme.colors.primary
    };
  }

  if (active && completed) {
    baseStyles.fontWeight = '900';
    baseStyles.margin = '15px';
    baseStyles['& .progressIndicator'] = {
      fontWeight: '800',
      color: theme.colors.primary,
      backgroundColor: theme.colors.primary
    };
    baseStyles['&'] = {
      fontWeight: '800',
      color: theme.colors.primary
    };
    baseStyles['& button'] = {
      color: theme.colors.primary
    };
  }

  if (disabled) {
    baseStyles['& button'] = {
      cursor: 'not-allowed',
      color: theme.colors.disabled
    };
    baseStyles['&'] = {
      fontWeight: '100',
      color: 'lightgray',
      cursor: 'not-allowed'
    };
    baseStyles['& .progressIndicator'] = {
      backgroundColor: 'lightgray',
      cursor: 'not-allowed'
    };
  }

  return baseStyles;
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@nike/ruxac/components/Step/Step.style.js
// module id = 551
// module chunks = 0